import { Box } from '@src/atoms/Box';
import { Button } from '@src/atoms/Button';
import { Icon, TIconName } from '@src/atoms/Icon';
import React, { CSSProperties, FC } from 'react';
import { DropzoneState } from 'react-dropzone';
import styled from './MediaUploaderButtonOuter.module.scss';

interface IMediaUploaderButtonOuterProps {
  dropzone: DropzoneState;
  outerButtonText: string;
  outerButtonIcon?: TIconName;
}

export const MediaUploaderButtonOuter: FC<IMediaUploaderButtonOuterProps> = ({
  dropzone,
  outerButtonText,
  outerButtonIcon,
}) => {
  const inputStyles: CSSProperties = {
    ...dropzone.getInputProps().style,
    display: 'block',
  };

  return (
    <Box data-elem="MediaUploaderButtonOuterBox" className={styled.wrapper}>
      <div className={styled.inputContainer}>
        <input {...dropzone.getInputProps()} style={inputStyles} data-testid="dropzone" />
      </div>
      {outerButtonIcon ? (
        <Icon view="basicGreySemiDark" name={outerButtonIcon} size={'md'} className={styled.cursor} />
      ) : (
        <Button id="outerButton">{outerButtonText}</Button>
      )}
    </Box>
  );
};
